import { render, staticRenderFns } from "./Webinar.vue?vue&type=template&id=bda4507a&scoped=true"
import script from "./Webinar.vue?vue&type=script&lang=js"
export * from "./Webinar.vue?vue&type=script&lang=js"
import style0 from "./Webinar.vue?vue&type=style&index=0&id=bda4507a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda4507a",
  null
  
)

export default component.exports